export const US_STATES = {
  ALABAMA: "AL",
  ALASKA: "AK",
  ARIZONA: "AZ",
  ARKANSAS: "AR",
  CALIFORNIA: "CA",
  COLORADO: "CO",
  CONNECTICUT: "CT",
  DELAWARE: "DE",
  FLORIDA: "FL",
  GEORGIA: "GA",
  HAWAII: "HI",
  IDAHO: "ID",
  ILLINOIS: "IL",
  INDIANA: "IN",
  IOWA: "IA",
  KANSAS: "KS",
  KENTUCKY: "KY",
  LOUISIANA: "LA",
  MAINE: "ME",
  MARYLAND: "MD",
  MASSACHUSETTS: "MA",
  MICHIGAN: "MI",
  MINNESOTA: "MN",
  MISSISSIPPI: "MS",
  MISSOURI: "MO",
  MONTANA: "MT",
  NEBRASKA: "NE",
  NEVADA: "NV",
  NEWHAMPSHIRE: "NH",
  NEWJERSEY: "NJ",
  NEWMEXICO: "NM",
  NEWYORK: "NY",
  NORTHCAROLINA: "NC",
  NORTHDAKOTA: "ND",
  OHIO: "OH",
  OKLAHOMA: "OK",
  OREGON: "OR",
  PENNSYLVANIA: "PA",
  RHODEISLAND: "RI",
  SOUTHCAROLINA: "SC",
  SOUTHDAKOTA: "SD",
  TENNESSEE: "TN",
  TEXAS: "TX",
  UTAH: "UT",
  VERMONT: "VT",
  VIRGINIA: "VA",
  WASHINGTON: "WA",
  WESTVIRGINIA: "WV",
  WISCONSIN: "WI",
  WYOMING: "WY",
};

export function normalizePostalCode(value) {
  return String(value || "")
    .toUpperCase()
    .replace(/[^A-Z0-9 -]/g, "")
    .slice(0, 10)
    .trim();
}

export function normalizePhoneNumber(value) {
  return String(value || "").replace(/\D/g, "");
}

export function buildAddressPayload(addressData, { includeUserUuid = true } = {}) {
  const payload = {
    name: String(addressData?.name || "").trim(),
    email: String(addressData?.email || "").trim(),
    mobile: normalizePhoneNumber(addressData?.mobile || addressData?.phone),
    apartment_number: String(addressData?.apartment_number || "").trim(),
    address: String(addressData?.address || addressData?.street || "").trim(),
    city: String(addressData?.city || "").trim(),
    state: String(addressData?.state || "").trim(),
    pincode: normalizePostalCode(addressData?.pincode || addressData?.zip || addressData?.zipcode),
  };

  if (includeUserUuid && addressData?.user_uuid) {
    payload.user_uuid = addressData.user_uuid;
  }

  return payload;
}

